
import React, { useMemo } from "react";
import styled from "styled-components";
import StatisticTableHead from "./StatisticTableHead";
import StatisticTableRow from "./StatisticTableRow";
import { Table } from "../StatisticDesign";

const TableContainer = styled.div`
    width: 100%;
    border: 1px solid #e2e8e5;
    border-radius: 12px;
    background: white;
`;

const StatisticTable = ({
                            Dates = [],
                            selectedHouse,
                            Data
                        }) => {

    const Floors = Data?.[selectedHouse] ?? {};

    const visibleDates = useMemo(() => {
        return Dates.filter((date) => {

            return Object.values(Floors).some((floorData) => {

                return Object.values(
                    floorData.ProgressWorks ?? {}
                ).some((works) => {

                    return Object.values(works).some((values) => {

                        return values.some((item) =>
                            item.Data === date &&
                            Number(item.Percent) !== 0
                        );

                    });

                });

            });

        });
    }, [Dates, Floors]);

    return (
        <TableContainer>
            <Table>

                <StatisticTableHead
                    Dates={visibleDates}
                />

                <tbody>
                {Data?.[selectedHouse] && (
                    <StatisticTableRow
                        Floors={Floors}
                        Dates={visibleDates}
                        house={selectedHouse}
                        frontId={Data.frontId}
                    />
                )}
                </tbody>

            </Table>
        </TableContainer>
    );
};

export default StatisticTable;
